import React, { Fragment } from 'react';
import { NavLink, useParams } from 'react-router-dom';
import { Row, Nav, NavItem } from 'reactstrap';
import classnames from 'classnames';
import IntlMessages from '../../helpers/IntlMessages';
import { Colxx, Separator } from '../../components/common/CustomBootstrap';
import Breadcrumb from '../../containers/navs/Breadcrumb';

import ESGDataListView from '../../containers/reports/ESGDataListView';

export default function ESG(props) {
  const { tabId } = useParams();

  // Render
  return (
    <Fragment>
      <Row>
        <Colxx xxs="12">
          <Breadcrumb heading="admin.esg.title" match={props.match} />
          <Separator className="mb-5" />
        </Colxx>
      </Row>
      <Row>
        <Colxx xxs="12" className="mb-4">
          <div>
            <Nav className="admin-tabs">
              <NavItem>
                <NavLink
                  to="/data/esg/details"
                  className={classnames({
                    active: !tabId || tabId === 'details',
                    'nav-link': true,
                  })}
                >
                  <IntlMessages id="admin.data.details" />
                </NavLink>
              </NavItem>
            </Nav>

            {!tabId || tabId === 'details' ? (
              <ESGDataListView path="/data/esg/details" />
            ) : null}
          </div>
        </Colxx>
      </Row>
    </Fragment>
  );
}
